import { defineStore } from 'pinia'
import _ from 'lodash'

export const useServiceStore = defineStore('service', {
	state: () => {
		return {
			categories: [],
		}
	},
	getters: {
		ready: (state) => {
			return state.categories.length > 0 ?? false
		},
		filterCategories: (state) => {
			return state.categories.filter((category) => !category.exclude_from_lists)
		},
		featuredProjects: (state) => {
			return _.orderBy(
				_.uniqBy(
					state.categories.flatMap((category) => category.showcased_projects),
					'slug',
				),
				'sorting',
				'asc',
			).slice(0, 5)
		},
	},
	actions: {
		setup() {
			this.getCategories()
		},
		getCategories() {
			return axios
				.get('/api/service/categories')
				.then((categories) => {
					this.categories = categories.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
	},
})
